import { FormRow, FormSection } from 'framework/ui/layout';
import {
  EmployeeTypeDropdown,
  PositionDropdown,
  EDUCATION_SPECIALIST_ID,
  SOFTWARE_ENGINEER_ID,
} from 'domain/shared/employee';
import EmployeeWorkplaceDropdown from 'domain/people/employee/shared/input/EmployeeWorkplaceDropdown';
import { TechnologyDropdown, getTechnologyFilter } from 'domain/shared/career';
import { ClearAfterUnmountWrapper, EnumDropdown, useFormContext } from 'framework/form';
import type { ConversionPositionSlotFormData } from '../conversionPositionSlotFormData';
import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';

type HrInfoSectionProps = {
  positionSlot?: Nullable<ConversionPositionSlotFormData>;
};

const HrInfoSection = ({ positionSlot }: HrInfoSectionProps) => {
  const { data } = useFormContext();
  const { positionId } = data || {};
  const isPrefilledFromSlot = positionSlot != null;
  const isEmployeeTypeDisabled = positionSlot?.employeeType != null;
  const isTechnologyDisabled = positionSlot?.technologyId != null;

  return (
    <FormSection title="HR info">
      <FormRow>
        <EmployeeTypeDropdown label="Type" source="employeeType" disabled={isEmployeeTypeDisabled} />
        <PositionDropdown source="positionId" label="Position" disabled={isPrefilledFromSlot} />
        <ClearAfterUnmountWrapper
          isVisible={employee => {
            const id = Number(employee.positionId);
            return id === SOFTWARE_ENGINEER_ID || id === EDUCATION_SPECIALIST_ID;
          }}
        >
          <TechnologyDropdown
            customReduce={getTechnologyFilter(positionId)}
            deps={[positionId]}
            source="specializationInfo.technologyId"
            label="Technology"
            disabled={isTechnologyDisabled}
          />
        </ClearAfterUnmountWrapper>
        <EnumDropdown
          source="specializationInfo.competencyLevel"
          options={EMPLOYEE_COMPETENCY_LEVEL}
          label="Competency level"
          disabled={isPrefilledFromSlot}
        />
        <EmployeeWorkplaceDropdown source="extendedInformation.hrInformation.workplaceLocation" />
      </FormRow>
    </FormSection>
  );
};

export { HrInfoSection };
